module.exports = __webpack_public_path__ + "static/ParqueAtracciones-af04999e87299004a86dbeec537ea980.jpg";